import type { ReactNode } from 'react';

export const symbol_thermostat_carbon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.04-75.43Q447.07-79.87 438-88L88-438q-8.13-9.07-12.57-20.04Q71-469 71-480t4.43-22.34Q79.87-513.68 88-522l350-350q9.07-8.87 20.04-12.93Q469-889 480-889t22.34 4.07Q513.68-880.87 522-872l350 350q8.87 8.32 12.93 19.66Q889-491 889-480t-4.07 21.96Q880.87-447.07 872-438L522-88q-8.32 8.13-19.66 12.57Q491-71 480-71t-21.96-4.43ZM480-131l349-349-349-349-349 349 349 349Zm0-349Z"
		/>
	</svg>
);
